import { PropsWithChildren, useEffect, useState } from "react";
import "./styles.scss";
import classNames from "classnames";
import { Box, SxProps } from "@mui/material";

const getCorrectImage = (
  breakPoint: number,
  width: number,
  imageUrl: string,
  mobileImage?: string
) => (mobileImage && width < breakPoint ? mobileImage : imageUrl);

export const HeroImage = ({
  image,
  mobileImage,
  children,
  className,
  imageBreakPoint = 600,
  sx,
}: PropsWithChildren<{
  image: string;
  className?: string;
  mobileImage?: string;
  imageBreakPoint?: number;
  sx?: SxProps;
}>) => {
  const [imageUrl, setImageUrl] = useState(
    getCorrectImage(imageBreakPoint, window.innerWidth, image, mobileImage)
  );

  useEffect(() => {
    const resizeListener = () => {
      const newUrl = getCorrectImage(
        imageBreakPoint,
        window.innerWidth,
        image,
        mobileImage
      );
      if (newUrl !== imageUrl) {
        setImageUrl(newUrl);
      }
    };
    if (mobileImage) {
      window.addEventListener("resize", resizeListener);
      return () => window.removeEventListener("resize", resizeListener);
    }
  }, [imageUrl, image, mobileImage, imageBreakPoint]);

  return (
    <Box
      sx={{
        backgroundImage: `url(${imageUrl})`,
        ...sx,
      }}
      className={classNames("hero-image-container", className)}
    >
      {children && <div className="hero-image-content">{children}</div>}
    </Box>
  );
};
